import { Info } from "lucide-react"

import { Card, CardContent } from "@/components/ui/card"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import { cn } from "@/lib/utils"

interface StatCardProps {
  title: string
  value: string | number
  subValue?: string | number
  subLabel?: string
  change?: { label: string; positive: boolean }
  tooltip?: string
}

export function StatCard({
  title,
  value,
  subValue,
  subLabel,
  change,
  tooltip,
  className,
}: StatCardProps & { className?: string }) {
  return (
    <Card className={cn("rounded-xl", className)}>
      <CardContent>
        <div className="text-muted-foreground flex items-center justify-between text-sm leading-6 font-medium">
          {title}
          {tooltip && (
            <Tooltip>
              <TooltipTrigger asChild>
                <Info className="text-muted-foreground size-3.5 cursor-default" />
              </TooltipTrigger>
              <TooltipContent className="max-w-56">{tooltip}</TooltipContent>
            </Tooltip>
          )}
        </div>
        <div className="mt-4 text-3xl font-normal tracking-tight">{value}</div>
        {(change || subValue || subLabel) && (
          <div className="mt-2 text-sm">
            {change && (
              <span
                className={`inline-flex items-center rounded-md px-1.5 py-0.5 text-xs font-medium ${
                  change.positive
                    ? "bg-green-100 text-green-700 dark:bg-green-400/10 dark:text-green-400"
                    : "bg-red-100 text-red-700 dark:bg-red-400/10 dark:text-red-400"
                }`}
              >
                {change.label}
              </span>
            )}{" "}
            {subValue && (
              <span className="text-foreground font-medium">{subValue}</span>
            )}
            {subLabel && (
              <span className="text-muted-foreground"> {subLabel}</span>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  )
}
